"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = exports.Decorator = exports.SelectItem = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_flex_1 = require("@hopin-team/ui-flex");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var area = ui_blocks_1.INTERACTIVE.area,
    isInFocus = ui_blocks_1.INTERACTIVE.isInFocus,
    isInFocusInverse = ui_blocks_1.INTERACTIVE.isInFocusInverse;
var emphasis = ui_blocks_1.TYPOGRAPHY.emphasis;
var isInverseStyles = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  background-color: transparent;\n  color: ", ";\n\n  &[aria-disabled='false'] {\n    &:hover {\n      background: ", ";\n      color: ", ";\n    }\n\n    &:active {\n      background-color: ", ";\n    }\n\n    &:focus-visible {\n      ", "\n    }\n  }\n\n  &[aria-disabled='true'],\n  &[aria-disabled='true']:hover {\n    color: ", ";\n  }\n"], ["\n  background-color: transparent;\n  color: ", ";\n\n  &[aria-disabled='false'] {\n    &:hover {\n      background: ", ";\n      color: ", ";\n    }\n\n    &:active {\n      background-color: ", ";\n    }\n\n    &:focus-visible {\n      ", "\n    }\n  }\n\n  &[aria-disabled='true'],\n  &[aria-disabled='true']:hover {\n    color: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY.WHITE", theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY[\"700\"]", theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY.WHITE", theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["900"]', theme);
}, isInFocusInverse, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["400"]', theme);
});
exports.SelectItem = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 0.75rem;\n  gap: 0.75rem;\n\n  ", "\n  ", "\n  border: 0.0625rem solid transparent;\n  color: ", ";\n\n  &[aria-disabled='false'] {\n    &:hover {\n      background-color: ", ";\n      border: 0.0625rem solid transparent;\n    }\n\n    &:active {\n      background-color: ", ";\n    }\n\n    &:focus-visible {\n      ", "\n    }\n  }\n\n  &[aria-disabled='true'],\n  &[aria-disabled='true']:hover {\n    color: ", ";\n  }\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 0.75rem;\n  gap: 0.75rem;\n\n  ", "\n  ", "\n  border: 0.0625rem solid transparent;\n  color: ", ";\n\n  &[aria-disabled='false'] {\n    &:hover {\n      background-color: ", ";\n      border: 0.0625rem solid transparent;\n    }\n\n    &:active {\n      background-color: ", ";\n    }\n\n    &:focus-visible {\n      ", "\n    }\n  }\n\n  &[aria-disabled='true'],\n  &[aria-disabled='true']:hover {\n    color: ", ";\n  }\n\n  ", "\n"])), area, emphasis, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["800"]', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["100"]', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.BLUE["100"]', theme);
}, isInFocus, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["600"]', theme);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'isInverse', isInverseStyles);
});

var makeWidthStyles = function makeWidthStyles(_a) {
  var hasAvatar = _a.hasAvatar,
      hasLogo = _a.hasLogo,
      hasMedia = _a.hasMedia,
      hasSubtext = _a.hasSubtext;

  if (hasAvatar) {
    if (hasSubtext) {
      return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n        width: 2.5rem;\n      "], ["\n        width: 2.5rem;\n      "])));
    } else {
      return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n        width: 1.5rem;\n      "], ["\n        width: 1.5rem;\n      "])));
    }
  }

  if (hasLogo) {
    return (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n      width: 2.5rem;\n    "], ["\n      width: 2.5rem;\n    "])));
  }

  if (hasMedia) {
    return (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n      width: 5rem;\n    "], ["\n      width: 5rem;\n    "])));
  }

  return '';
};

exports.Decorator = styled_components_1.default.div(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  ", "\n"])), function (props) {
  return makeWidthStyles(props);
});
exports.Content = (0, styled_components_1.default)(ui_flex_1.Flex)(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n  flex-grow: 1;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"], ["\n  flex-grow: 1;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;